import { Flex, Box } from '@chakra-ui/react';

interface StepProgressProps {
  total: number;
  current: number;
}

export function StepProgress({ total, current }: StepProgressProps) {
  return (
    <Flex gap="2" align="center" justify="center" w="full">
      {Array.from({ length: total }, (_, i) => i).map((i) => {
        const reached = i <= current;
        return (
          <Box
            key={i}
            data-testid="step-progress-segment"
            h="2"
            flex="1"
            maxW="56px"
            borderRadius="full"
            bg={reached ? 'volyx.action' : 'volyx.lightGray'}
            transition="background-color 0.2s"
          />
        );
      })}
    </Flex>
  );
}
